import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { PROJECTS } from "../lib/projects";

export default function NextProject({ currentId }) {
  const i = PROJECTS.findIndex((p) => p.id === currentId);
  const next = PROJECTS[(i + 1) % PROJECTS.length];
  const to = next.page || `/projects#${next.id}`;

  return (
    <section className="border-t border-[#E2E2DF]" data-testid="next-project-section">
      <Link to={to} className="group block" data-testid="next-project-link">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-24 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-20 items-center">
          <div className="md:col-span-5 order-2 md:order-1">
            <Reveal>
              <span className="eyebrow-muted">Next Project</span>
              <p className="mt-8 font-heading text-2xl md:text-3xl lg:text-4xl text-[#111111] leading-[1.15] font-medium tracking-tight group-hover:text-[#EB1D25] transition-colors duration-300" data-testid="next-project-name">
                {next.name}
              </p>
              <p className="mt-3 text-[#545454] text-sm">{next.location} — {next.category}</p>
              <span className="mt-10 inline-flex items-center gap-3 text-[#111111] font-heading uppercase tracking-[0.22em] text-[11px] font-semibold">
                View next
                <ArrowRight size={14} strokeWidth={1.5} className="transition-transform duration-500 group-hover:translate-x-2" />
              </span>
            </Reveal>
          </div>
          <div className="md:col-span-7 order-1 md:order-2">
            <Reveal delay={120}>
              <div className="overflow-hidden aspect-[16/9] bg-[#EDEBE6]">
                <img
                  src={next.image}
                  alt={next.name}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-[1500ms] ease-out group-hover:scale-[1.04]"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </Link>
    </section>
  );
}
